import React from 'react';
import useObservable from '../../../../../../Shared/Hooks/useObservable.Hook';
import {
  getSearchStatus,
  getSearchSubject,
} from '../../../../../Services/Search.service';
import BreadcrumbsWrapper from '../../../HeaderWrapper/BreadcrumbsWrapper/BreadcrumbsWrapper';
import SearchResultsText from '../../../HeaderWrapper/SearchResultsText/SearchResultsText';
import MobileActionsMenuTop from './ActionsMenu/MobileActionsMenuTop';
import SortWrapper from '../../../TableWrapper/TableHeaderWrapper/TableHeader/Sort/SortWrapper';
import { classes, st } from './MobileHeaderTop.st.css';

const MobileHeaderTop = () => {
  const [error1, searchStatus]: any = useObservable(getSearchStatus());
  const [error2, searchSubject]: any = useObservable(getSearchSubject());

  return (
    <div className={st(classes.mobileHeaderContainer)}>
      {searchStatus === undefined || searchStatus === false ? (
        <div className={st(classes.mobileBreadcrumbsContainer)}>
          <BreadcrumbsWrapper />
        </div>
      ) : (
        <div className={st(classes.mobileSearchResultsContainer)}>
          <SearchResultsText />
        </div>
      )}
      <div className={st(classes.mobileIconsContainer)}>
        {searchSubject !== undefined &&
        (searchSubject.value === '' || searchSubject.value === undefined) ? (
          <SortWrapper />
        ) : null}
        <div>
          <MobileActionsMenuTop />
        </div>
      </div>
    </div>
  );
};

export default MobileHeaderTop;
